import React from 'react';

export function VerifyUserIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M24.406 2.18a1 1 0 00-.812 0l-17 7.556A1 1 0 006 10.65V22c0 11.015 7.563 21.32 17.763 23.94.155.04.319.04.474 0C34.437 43.32 42 33.016 42 22V10.65a1 1 0 00-.594-.914l-17-7.555zM38 22c0 8.93-5.815 17.176-13.706 19.766a.943.943 0 01-.588 0C15.816 39.176 10 30.93 10 22v-9.4l13.594-6.04a1 1 0 01.812 0L38 12.6V22zm-22.473 1.884a1 1 0 00-1.413.002l-1.407 1.407a1 1 0 000 1.414l6.586 6.586a1 1 0 001.414 0l14.588-14.588a1 1 0 00.003-1.412l-1.41-1.42a1 1 0 00-1.418-.003L20 28.34l-4.473-4.456z" />
    </svg>
  );
}
